// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import travelEntity from './entities/travel.json';
import travelMenu from '../pages/travel/menu.json';
import travelFullForm from '../pages/travel/forms/full.json';
import travelContextForm from '../pages/travel/forms/context.json';
import travelMiniForm from '../pages/travel/forms/mini.json';
import travelLookupForm from '../pages/travel/forms/lookup.json';
import travelTableView from '../pages/travel/views/table.json';
import travelStagesView from '../pages/travel/views/stages.json';
import travelCardsView from '../pages/travel/views/cards.json';
import travelInlineView from '../pages/travel/views/inline.json';
import travelBacklogView from '../pages/travel/views/backlog.json';
import travelSplitView from '../pages/travel/views/split.json';
import travelCalendarView from '../pages/travel/views/calendar.json';
import travelDashboardView from '../pages/travel/views/dashboard.json';

/** Тип запису «Поїздка» зі сторінками пакета: меню, форми та подання з pages/travel/. */
export const travelDefinition: IRecordTypeDefinition = {
  ...travelEntity,
  views: assembleViewSet({
      table: travelTableView,
      stages: travelStagesView,
      cards: travelCardsView,
      inline: travelInlineView,
      backlog: travelBacklogView,
      split: travelSplitView,
      calendar: travelCalendarView,
      dashboard: travelDashboardView,
  }),
  form: travelFullForm,
  forms: { full: travelFullForm, context: travelContextForm, mini: travelMiniForm, lookup: travelLookupForm },
  menu: travelMenu,
} as IRecordTypeDefinition;
